import { useCallback, useEffect, useReducer, useRef } from 'react';
import PropTypes from 'prop-types';

import { Issuer } from 'src/utils/auth';
import { AuthContext, initialState } from './auth-context';
import {
  startAuth,
  isauthed,
  getRoles,
  getMe,
  stopAuth,
  refreshRole,
} from 'src/services/RestApi';

import {showLog} from 'src/utils/debug-log';

var ActionType;
(function (ActionType) {
  ActionType['INITIALIZE'] = 'INITIALIZE';
  ActionType['SIGN_IN'] = 'SIGN_IN';
  // ActionType['SIGN_UP'] = 'SIGN_UP';
  ActionType['SIGN_OUT'] = 'SIGN_OUT';
  ActionType['CHANGE_ROLE'] = 'CHANGE_ROLE';
})(ActionType || (ActionType = {}));

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user, roles, currentRole } = action.payload;

    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
      roles,
      currentRole,
    };
  },
  SIGN_IN: (state, action) => {
    const { user, roles, currentRole } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      roles,
      currentRole,
    };
  },
  // SIGN_UP: (state, action) => {
  //   const { user } = action.payload;

  //   return {
  //     ...state,
  //     isAuthenticated: true,
  //     user,
  //   };
  // },
  SIGN_OUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    roles: null,
    currentRole: null,
  }),
  CHANGE_ROLE: (state, action) => {
    const { currentRole } = action.payload;

    return {
      ...state,
      currentRole,
    };
  },
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

export const AuthProvider = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const initialized = useRef(false);

  const initialize = useCallback(async () => {
    // Prevent from calling twice in development mode with React.StrictMode enabled
    if (initialized.current) {
      return;
    }
    showLog('<<< INIT -- INIT >>>');
    initialized.current = true;

    try {
      const bAuthed = isauthed();
      if (bAuthed) {
        const userRole = getRoles();
        const currentRole = refreshRole();

        const account = await getMe();
        dispatch({
          type: ActionType.INITIALIZE,
          payload: {
            isAuthenticated: true,
            user: account,
            roles: userRole,
            currentRole: currentRole,
          },
        });
      } else {
        dispatch({
          type: ActionType.INITIALIZE,
          payload: {
            isAuthenticated: false,
            user: null,
            roles: null,
            currentRole: null,
          },
        });
      }
    } catch (err) {
     
      dispatch({
        type: ActionType.INITIALIZE,
        payload: {
          isAuthenticated: false,
          user: null,
          roles: null,
          currentRole: null,
        },
      });
    }
  }, [dispatch]);

  useEffect(() => {
    showLog('<<< --- INIT --- >>>');
    initialize();
  }, []);

  const signIn = useCallback(
    async (username, password) => {
      // Check validation
      if (username === '' || password === '') {
        // Please check your username and password
        throw new Error('Vui lòng kiềm Mã đăng nhập và Mật khẩu của bạn');
      }

      const queryParams = {
        username: username,
        password: password,
        grant_type: 'password',
      };
      // Api login
      const isSuccess = await startAuth(queryParams);

      if (!isSuccess) {
        // Invalid username or password
        throw new Error('Mã đăng nhập hoặc Mật khẩu chưa đúng');
      }
      const userRole = getRoles();
      const currentRole = refreshRole();

      const account = await getMe();
      dispatch({
        type: ActionType.SIGN_IN,
        payload: {
          user: account,
          roles: userRole,
          currentRole: currentRole,
        },
      });
    },
    [dispatch],
  );

  // const signUp = useCallback(
  //   async (email, name, password) => {
  //     throw new Error('Sign up is not implemented');
  //     // const { accessToken } = await authApi.signUp({ email, name, password });
  //     // const user = await authApi.me({ accessToken });

  //     // sessionStorage.setItem(STORAGE_KEY, accessToken);

  //     // dispatch({
  //     //   type: ActionType.SIGN_UP,
  //     //   payload: {
  //     //     user,
  //     //   },
  //     // });
  //   },
  //   [dispatch]
  // );

  const signOut = useCallback(async () => {
    showLog('===== LOGOUTED =====');
    // Handle logout
    // Clean cache
    
    stopAuth();
    dispatch({ type: ActionType.SIGN_OUT });
  }, [dispatch]);

  // const apiGetMe = async () => {
  //   // Check local storage before call api
  //   let cache = '';
  //   const response = await getData('api/getMyInfo', {});
  //   if(response){
  //     if(response.success){
  //       cache = response.data;
  //       localStorage.setItem('user_info', response.data);
  //     }
  //   }

  //   return localStorage.getItem('user_info');
  // }

  const changeRole = useCallback(
    async (roleName) => {
      showLog('===== Change Role =====', roleName);
      showLog('===== =========== =====');

      refreshRole(roleName);
      dispatch({
        type: ActionType.CHANGE_ROLE,
        payload: {
          currentRole: roleName,
        },
      });
    },
    [dispatch],
  );

  return (
    <AuthContext.Provider
      value={{
        ...state,
        issuer: Issuer.JWT,
        signIn,
        signOut,
        changeRole,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
